import { useState } from "react";

import type { MorphState } from "./useCardInlineStyle";

const TODAY_EVENT_MODAL_DISMISSED_KEY = "todayEventModalDismissed";
const CLOSE_DURATION_MS = 440;

// リロード時には dismissed フラグをクリアしてモーダルを再表示できるようにする。
// useState の initializer 内で行うと、コンポーネントが unmount/remount するたびに
// 実行されてしまい、closeModal で立てたフラグが消されてしまうため、
// モジュール初期化時に一度だけ実行する。
if (typeof window !== "undefined") {
  const [entry] = window.performance.getEntriesByType(
    "navigation"
  ) as PerformanceNavigationTiming[];
  if (entry?.type === "reload") {
    window.sessionStorage.removeItem(TODAY_EVENT_MODAL_DISMISSED_KEY);
  }
}

/**
 * @description
 * morphState は、"fab" | "modal" | "closing" のいずれかの状態を取る。
 * "fab"は、画面右下に小さなボタンが表示されている状態。
 * "modal"は、画面中央にモーダルでイベントの詳細が表示されている状態。
 * "closing"は、modalからfabに変化するアニメーション中の状態。
 *
 * 初期stateは sessionStorage の dismissed フラグを見て決定する
 * (リロード時のクリアはモジュール初期化時に実施済み)。
 */
export const useMorphState = (): {
  morphState: MorphState;
  openModal: () => void;
  closeModal: () => void;
} => {
  const [morphState, setMorphState] = useState<MorphState>(() => {
    if (typeof window === "undefined") return "modal";
    return window.sessionStorage.getItem(TODAY_EVENT_MODAL_DISMISSED_KEY) ===
      "1"
      ? "fab"
      : "modal";
  });

  const closeModal = () => {
    window.sessionStorage.setItem(TODAY_EVENT_MODAL_DISMISSED_KEY, "1");
    setMorphState("closing");
    window.setTimeout(() => {
      setMorphState((curr) => {
        return curr === "closing" ? "fab" : curr;
      });
    }, CLOSE_DURATION_MS);
  };

  const openModal = () => {
    setMorphState("modal");
  };

  return { morphState, openModal, closeModal };
};
